import { Box, NavLink } from '@mantine/core'
import { useLocation } from '@remix-run/react'
import {
  TbArticle,
  TbBuildings,
  TbCalendarEvent,
  TbCarouselHorizontal,
  TbDashboard,
  TbEdit,
  TbList,
  TbLogout,
  TbMailUp,
  TbTag,
  TbTicket,
  TbTicketOff,
  TbUser,
  TbUsers,
} from 'react-icons/tb'

import { PiStudentFill } from 'react-icons/pi'

type NavLinkProps = {
  link: string
  label: string
  icon: React.FC
  nested?: NavLinkProps[]
  target?: string
  disabled?: boolean
}

const data: NavLinkProps[] = [
  { link: '/admin', label: 'ダッシュボード', icon: TbDashboard },
  {
    link: '/admin/companies',
    label: '企業管理',
    icon: TbBuildings,
    nested: [
      { link: '/admin/companies', label: '企業一覧', icon: TbList },
      { link: '/admin/companies/new', label: '新規企業登録', icon: TbEdit },
      { link: '/admin/industries', label: '業界・業種管理', icon: TbBuildings },
    ],
  },
  {
    link: '/admin/events',
    label: 'イベント管理',
    icon: TbCalendarEvent,
    nested: [
      { link: '/admin/events', label: 'イベント一覧', icon: TbList },
      { link: '/admin/events/create', label: 'イベント作成', icon: TbEdit },
      { link: '/admin/tags', label: 'イベントタグ管理', icon: TbTag },
    ],
  },
  {
    link: '/admin/events',
    label: 'カルーセル管理',
    icon: TbCarouselHorizontal,
    nested: [
      { link: '/admin/carousel', label: 'トップ', icon: TbCarouselHorizontal },
      { link: '/admin/article', label: '記事', icon: TbArticle },
    ],
  },
  {
    link: '/admin/entries',
    label: 'エントリー管理',
    icon: TbTicket,
    nested: [
      {
        link: `https://airtable.com/${import.meta.env.VITE_AIRTABLE_ENTRY_BASE_ID}/${import.meta.env.VITE_AIRTABLE_ENTRY_TABLE_ID}`,
        label: '申込一覧',
        icon: TbTicket,
        target: '_blank',
      },
      {
        link: `https://airtable.com/${import.meta.env.VITE_AIRTABLE_TEMP_ENTRY_BASE_ID}/${import.meta.env.VITE_AIRTABLE_TEMP_ENTRY_TABLE_ID}`,
        label: '仮申込一覧',
        icon: TbTicketOff,
        target: '_blank',
      },
      {
        link: `https://airtable.com/${import.meta.env.VITE_AIRTABLE_STUDENTS_BASE_ID}/${import.meta.env.VITE_AIRTABLE_STUDENTS_TABLE_ID}`,
        label: '登録学生一覧',
        icon: PiStudentFill,
        target: '_blank',
      },
    ],
  },
  {
    link: '/admin/users',
    label: 'アドミンユーザー管理',
    icon: TbUser,
    nested: [
      { link: '/admin/users', label: 'アドミンユーザー一覧', icon: TbUsers },
      {
        link: '/admin/users/invite',
        label: 'アドミンユーザー招待',
        icon: TbMailUp,
      },
    ],
  },
]

export function AdminNavbar() {
  const location = useLocation()

  const links = data.map((item) => (
    <NavLink
      w={'100%'}
      key={item.label}
      href={item.link}
      label={item.label}
      active={item.nested?.length ? false : item.link === location.pathname}
      leftSection={<item.icon />}
      disabled={item.disabled}
      defaultOpened
    >
      {item.nested?.length &&
        item.nested.map((nestedItem) => (
          <NavLink
            key={nestedItem.label}
            href={nestedItem.link}
            label={nestedItem.label}
            component='a'
            target={nestedItem.target}
            active={nestedItem.link === location.pathname}
            leftSection={<nestedItem.icon />}
          />
        ))}
    </NavLink>
  ))

  return (
    <>
      {links}

      <Box>
        <NavLink
          key='Logout'
          href='/logout'
          label='ログアウト'
          leftSection={<TbLogout />}
        />
      </Box>
    </>
  )
}
